export const EMERGENCY_PLAN_SUPPORTED_SECTION_KEYS = {
  foreseeable_rescue_scenarios: true,
  rescue_equipment_staging: true,
  roles_responsibilities_competency: true,
  alarm_communication_emergency_access: true,
  emergency_contacts: true,
  emergency_response_procedure: true,
  medical_considerations: true,
  post_rescue_notification: true
};

export const formatSectionLabel = (sectionKey, sectionData) => {
  if (sectionData && sectionData.display_name) {
    return sectionData.display_name;
  }

  return String(sectionKey || "")
    .split("_")
    .map((token) => token.charAt(0).toUpperCase() + token.slice(1))
    .join(" ");
};

export const resolveEmergencyPlanSectionHeading = (sectionKey, sectionData) => {
  return formatSectionLabel(sectionKey, sectionData);
};
